import { Link } from '@reach/router';
import {
  Container,
  Icon,
  Image,
  Stack,
  Flex,
  Heading,
  Text,
  Button,
  useColorModeValue,
} from '@chakra-ui/react';

const NotFound = () => {
  return (
    <Flex align={'center'} justify={'center'} h={'100vh'} w={'full'}>
      <Stack
        as={Container}
        bg={useColorModeValue('gray.50', 'gray.900')}
        rounded={'xl'}
        p={8}
        spacing={6}
        maxW={'lg'}
        align={'center'}
        textAlign={'center'}
      >
        <Icon as={Image} w={10} h={10} src="/images/logo.png" />
        <Stack spacing={2}>
          <Heading>Page not found</Heading>
          <Text>
            This page was not found. You may have mistyped the address or the
            page may have moved.
          </Text>
        </Stack>
        <Flex>
          <Link to={'/'} passHref>
            <Button
              as={'a'}
              colorScheme={'yellow'}
              rounded={'full'}
              bg={'yellow.400'}
              _hover={{ bg: 'gray.900', color: 'white' }}
            >
              Take me to the home page
            </Button>
          </Link>
        </Flex>
      </Stack>
    </Flex>
  );
};

export default NotFound;
